export default __webpack_public_path__ + "static/Dupont-ab9c808037775b6c636db790de4306f4.png";